var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import useFetch from './useFetch';
import { getLinkApiHeaders, getLinkApiUrl, } from '../LinkApiRouter/utils/link-api-requests';
import { mapCamelKeysToSnakeKeysRecursively, mapSnakeKeysToCamelKeysRecursively, } from '../utils/case-conversion';
import { useOpts } from '../context';
var formatResponse = function (res) {
    var response = mapSnakeKeysToCamelKeysRecursively(res, {
        checkShouldRecursionStop: function (path) {
            return /^data\.template\.actions\.[0-9]+\.payload$/.test(path.join('.'));
        },
    });
    return response;
};
export default function useGenerateDDForm(fullName, employer, signatureStyle, allocation, action, options) {
    if (options === void 0) { options = {}; }
    var opts = useOpts();
    var headers = getLinkApiHeaders(opts);
    var requestBody = {
        fullName: fullName,
        employer: employer,
        orgName: opts.linkTokenPayload.orgName,
        signatureStyle: signatureStyle,
        allocation: allocation,
        action: action,
    };
    return useFetch("".concat(getLinkApiUrl('account'), "direct_deposit_forms"), { headers: headers, method: 'POST', body: requestBody }, __assign(__assign({}, options), { formatRequest: function (req) { return mapCamelKeysToSnakeKeysRecursively(req); }, formatResponse: formatResponse }));
}
